import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { Description } from './Description';
import { Allowed } from './Allowed';
import { PoolDetailsPanel } from './PoolDetailsPanel';

import { ContentListType } from '@/pages/Pool';
import { Loader, Tabs, TabsContent, TabsList, TabsTrigger } from '@/shared/ui';
import { Store } from '@/shared/store';

export const PoolDetailsTabs: React.FC = () => {
    const { address } = useParams<{ address: string }>();

    const { clientPool } = useSelector((state: Store) => ({
        clientPool: state.agreements.clientPool,
    }));

    if (clientPool.address !== address) {
        return <Loader />;
    }

    return (
        <Tabs defaultValue={ContentListType.DESCRIPTION} className='w-[100%]'>
            <TabsList className='w-[100%] pl-[10%] border-b-2 border-gray-200 justify-normal'>
                <TabsTrigger
                    className='max-w-[200px]'
                    value={ContentListType.DESCRIPTION}
                    data-testid='pool-details-description'
                >
                    Description
                </TabsTrigger>
                <TabsTrigger
                    className='max-w-[200px]'
                    value={ContentListType.ALLOWED}
                    data-testid='pool-details-allowed'
                >
                    Allowed Tokens
                </TabsTrigger>
            </TabsList>
            <TabsContent value={ContentListType.DESCRIPTION}>
                <div className='flex justify-between px-[10%] py-9'>
                    <Description
                        description={clientPool.description || ''}
                        chart={clientPool.apyHistory}
                    />
                    <PoolDetailsPanel clientPool={clientPool} />
                </div>
            </TabsContent>
            <TabsContent value={ContentListType.ALLOWED}>
                <div className='flex justify-between px-[10%] py-9'>
                    <Allowed tokens={clientPool.stressTestMatrix} />
                    <PoolDetailsPanel clientPool={clientPool} />
                </div>
            </TabsContent>
        </Tabs>
    );
};
